/**
 * 异步字体加载模块
 * 使用 FontFace API 动态加载字体，避免阻塞首屏渲染
 */

const FONT_CONFIG = [
  {
    family: 'FZYanSJW',
    url: require('../pages/app-router/font/FZYanSJW.TTF'),
  },
  {
    family: 'SourceHanSansCN',
    url: require('../pages/app-router/font/SourceHanSansCN-Normal.otf'),
  },
];

/**
 * 加载单个字体
 * @param {string} family - 字体族名称
 * @param {string} url - 字体文件 URL
 * @returns {Promise}
 */
function loadFont(family, url) {
  return new Promise((resolve, reject) => {
    // 检查浏览器是否支持 FontFace API
    if (typeof FontFace === 'undefined') {
      // 不支持 FontFace API 时，依赖 CSS @font-face 加载
      resolve();
      return;
    }

    const font = new FontFace(family, `url(${url})`);
    
    font.load()
      .then((loadedFont) => {
        document.fonts.add(loadedFont);
        resolve(loadedFont);
      })
      .catch((error) => {
        console.warn(`字体加载失败：${family}`, error);
        reject(error);
      });
  });
}

/**
 * 加载所有配置的字体
 * @param {boolean} sequential - 是否顺序加载（默认并发加载）
 * @returns {Promise}
 */
export function loadFonts(sequential = false) {
  if (sequential) {
    // 顺序加载，优先级高的字体先加载
    return FONT_CONFIG.reduce(
      (promise, font) => promise.then(() => loadFont(font.family, font.url)),
      Promise.resolve()
    );
  } else {
    // 并发加载所有字体
    return Promise.all(
      FONT_CONFIG.map((font) => loadFont(font.family, font.url))
    );
  }
}

/**
 * 在页面空闲时加载字体（使用 requestIdleCallback）
 * @returns {Promise}
 */
export function loadFontsWhenIdle() {
  return new Promise((resolve) => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        loadFonts().then(resolve).catch(resolve);
      });
    } else {
      // 不支持 requestIdleCallback 时，在下一帧加载
      requestAnimationFrame(() => {
        loadFonts().then(resolve).catch(resolve);
      });
    }
  });
}

export default {
  loadFonts,
  loadFontsWhenIdle,
  loadFont,
};
